export class ConvertHelper {

  public static toDate(value: string, culture = 'de'): string {
    const date = new Date(value);
    return date.toLocaleDateString(culture, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  }

  public static toISOTimeString(date: Date): string {
    if (date) {
      let d = new Date(date);

      let hours: string = '' + d.getHours();
      let minutes: string = '' + d.getMinutes();
      let seconds: string = '' + d.getSeconds();

      if (hours.length < 2) hours = '0' + hours;
      if (minutes.length < 2) minutes = '0' + minutes;
      if (seconds.length < 2) seconds = '0' + seconds;

      return [hours, minutes, seconds].join(':');
    } else {
      return null;
    }
  }

  public static toTime(value: string): string {
    const date = new Date(value);
    return date.toLocaleTimeString('de', { hour: '2-digit', minute: '2-digit' });
  }

  public static resolveStringPlaceholders(str, ...values) {
    const regex = /{\w+}/g;
    const placeholders = str.match(regex);
    let placeHoldersResolver = {};
    values.forEach((value, index) => {
      placeHoldersResolver[placeholders[index]] = value;
    });
    return str.replace(/{\w+}/g, (all) => {
      return placeHoldersResolver[all] || all;
    });
  }

  // Turn enum into array
  public static ToArray(enumeration) {
    let toArray: Object[];
    Object.keys(enumeration).forEach((key) => {
      if (!toArray) toArray = [];
      const obj = {
        id: key,
        label: enumeration[key]
      };
      toArray.push(obj);
    });
    return toArray;
  }
}

export class CompareHelper {
  public static isEmptyObject(obj: any): boolean {
    return !obj || (Object.entries(obj).length === 0 && obj.constructor === Object);
  }
}
export class GUID {
  public static newGUID() {
    let timestamp = new Date().getTime(); //Timestamp


    let timeInMicroSeconds = (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = Math.random() * 16; //random number between 0 and 16
      if (timestamp > 0) {
        //Use timestamp until depleted
        r = (timestamp + r) % 16 | 0;
        timestamp = Math.floor(timestamp / 16);
      } else {
        //Use microseconds since page-load if supported
        r = (timeInMicroSeconds + r) % 16 | 0;
        timeInMicroSeconds = Math.floor(timeInMicroSeconds / 16);
      }
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }
}


export class ObjectHelper {
  /**
* Deep merge two objects.
* @param target
* @param ...sources
*/
  public static mergeDeep(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();

    if (ObjectHelper.isObject(target) && ObjectHelper.isObject(source)) {
      for (const key in source) {
        if (ObjectHelper.isObject(source[key])) {
          if (!target[key]) Object.assign(target, { [key]: {} });
          ObjectHelper.mergeDeep(target[key], source[key]);
        } else {
          Object.assign(target, { [key]: source[key] });
        }
      }
    }

    return ObjectHelper.mergeDeep(target, ...sources);
  }

  public static groupByListItems(list, groupByKey, key) {
    return list.reduce((arr, obj) => {
      (arr[obj[groupByKey]] = arr[obj[groupByKey]] || []).push(obj[key]);
      return arr;
    }, {});
  };

  public static deepClone(objectpassed) {
    if (objectpassed === null || typeof objectpassed !== 'object') {
      return objectpassed;
    }
    var temporary = objectpassed.constructor();
    for (var key in objectpassed) {
      temporary[key] = this.deepClone(objectpassed[key]);
    }
    return temporary;
  }

  public static isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
  }
}